import { Profiler } from '@eti/utils';
import { Stack } from '@etg/wings';
import SeatMapProductCard from './SeatMapProductCard';
import SeatMapOverlay from './SeatMapOverlay';
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
const SeatMapProduct = _ref => {
  let {
    form,
    isSeatMapModalOpen,
    setIsSeatMapModalOpen,
    order,
    travelers,
    isSeatMapSelected,
    priceRaw,
    bounds
  } = _ref;
  return /*#__PURE__*/_jsx(Stack, {
    "data-testid": "SeatMapNewLayout",
    children: /*#__PURE__*/_jsx(Profiler, {
      id: "TravelerDetails-SeatMap",
      children: /*#__PURE__*/_jsxs(_Fragment, {
        children: [/*#__PURE__*/_jsx(SeatMapProductCard, {
          bounds: bounds,
          form: form,
          isSeatMapSelected: isSeatMapSelected,
          priceRaw: priceRaw,
          setIsSeatMapModalOpen: setIsSeatMapModalOpen
        }), /*#__PURE__*/_jsx(SeatMapOverlay, {
          bounds: bounds,
          form: form,
          order: order,
          setIsSeatMapModalOpen: setIsSeatMapModalOpen,
          show: isSeatMapModalOpen,
          travelers: travelers
        })]
      })
    })
  });
};
export default SeatMapProduct;
//# sourceMappingURL=SeatMapProduct.js.map